
























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import ContentEditor from '@/dex-shared/components/new_content/ContentEditor.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import KnowledgeAssociation from '@/components/knowledge/KnowledgeAssociation.vue';

export default Vue.extend({
  components: {
    ContentEditor,
    Loading,
    pxCard,
    pxButton,
    KnowledgeAssociation,
  },

  data() {
    return {
      creating: true,
      pushingArticle: false,
      loaded: true,
    };
  },

  computed: {
    ...mapGetters({
      articleById: 'articleById',
    }),
    article() {
      return this.articleById(+this.$route.params.articleId);
    },
    title: {
      get() {
        return this.article.title;
      },
      set(title: string) {
        this.$store.commit('UPDATE_ENTITY', {
          entity: 'articles',
          data: {
            ...this.article.raw(),
            title,
          },
        });
      },
    },
    group: {
      get() {
        return this.article.group;
      },
      set(group: string) {
        this.$store.commit('UPDATE_ENTITY', {
          entity: 'articles',
          data: {
            ...this.article.raw(),
            group,
          },
        });
      },
    },
  },

  async mounted() {
    this.loaded = false;
    this.creating = this.$route.name === 'article_create';
    if (this.creating) {
      let articleId = await this.$store.dispatch('CREATE_ARTICLE');
      this.$router.push(`/editar_explicacao/${articleId}`);
    } else {
      let articleId = +this.$route.params.articleId;
      await this.$store.dispatch('PULL_ARTICLE_BY_ID', articleId);
      //TODO no article found
    }
    this.loaded = true;
  },

  methods: {
    pushArticle: async function() {
      //TODO remove null contents
      if (this.pushingArticle === false) {
        this.pushingArticle = true;
        let error;
        try {
          await this.$store.dispatch('PUSH_ARTICLE_BY_ID', this.article.id);
          await this.$store.dispatch('UPDATE_KNOWLEDGE_ASSOCIATIONS', {
            type: 'article',
            id: this.article.id,
          });
        } catch (e) {
          error = e;
          alert(
            `Algo deu errado. Envie essas informações para os desenvolvedores: ${error}`,
          );
        }
        this.pushingArticle = false;
        //TODO error inputing article
        if (this.article.id && !error) {
          this.$router.push(`/explicacao/${this.article.id}`);
        }
      }
    },
  },
});
